module.exports = __webpack_public_path__ + "static/media/scan_qr_icon.d7308091.svg";